(ns frontend.view.nev.kyc.process.screening-profiles.event
  (:require
   [frontend.view.nev.kyc.process.screening-profiles.model :as model]
   [re-frame.core :as rf]))

(rf/reg-event-db
 ::profile-id-resolved
 [rf/trim-v]
 (fn [db [{:keys [kyc-process-id] :as args}]]
   (assoc-in db (model/profile-id-path kyc-process-id) (model/profile-id-resolved args))))

(rf/reg-event-db
 ::profile-id-failed
 [rf/trim-v]
 (fn [db [{:keys [kyc-process-id error]}]]
   (assoc-in db (model/profile-id-path kyc-process-id) (model/profile-id-failed error))))

(rf/reg-event-db
 ::entities-received
 [rf/trim-v]
 (fn [db [{:keys [kyc-profile-id] :as args}]]
   (update-in db (model/state-path kyc-profile-id) model/entities-received args)))

(rf/reg-event-db
 ::load-failed
 [rf/trim-v]
 (fn [db [{:keys [kyc-profile-id error]}]]
   (update-in db (model/state-path kyc-profile-id) model/failed error)))

(rf/reg-event-db
 ::cleared
 [rf/trim-v]
 (fn [db [{:keys [kyc-process-id]}]]
   (model/cleared db kyc-process-id)))
